(() => {
  const PFAND_HANDLE = 'deposit-pfand';
  const PFAND_HEADER = 'X-PFAND-SYNC';

  let lock = false;
  let timer = null;

  const getPfandVariantId = () => Number(window.PFAND_VARIANT_ID || 0);

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  function isPfandNeeded(item) {
    const v = item?.properties?._pfand;
    return v === 1 || v === '1' || v === true || v === 'true';
  }

  function isPfandLine(item, pfandVariantId) {
    if (pfandVariantId && Number(item?.id) === Number(pfandVariantId)) return true; // item.id === variant_id
    return item?.handle === PFAND_HANDLE;
  }

  async function setLineQty(line, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', [PFAND_HEADER]: '1' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity: qty }),
    });

    
    const data = await res.json().catch(() => null);
    if (!res.ok || (data && data.status && data.status !== 200)) {
      const msg = data?.description || data?.message || 'cart/change failed';
      throw new Error(msg);
    }
    return data;
  }

  async function addPfand(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', [PFAND_HEADER]: '1' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });

    const data = await res.json().catch(() => null);
    if (!res.ok || (data && data.status && data.status !== 200)) {
      const msg = data?.description || data?.message || 'cart/add failed';
      throw new Error(msg);
    }
    return data;
  }

  async function fetchSections(sectionNames) {
    const url = `${routes.cart_url}?sections=${encodeURIComponent(sectionNames.join(','))}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    const ct = res.headers.get('content-type') || '';
    if (!ct.includes('application/json')) throw new Error(`sections not json: ${ct}`);
    return await res.json();
  }

  function parseHTML(htmlString) {
    return new DOMParser().parseFromString(htmlString, 'text/html');
  }

  function replaceByIdFromHTML(id, htmlDoc) {
    const src = htmlDoc.getElementById(id);
    const dst = document.getElementById(id);
    if (src && dst) dst.replaceWith(src);
  }

  function setEmptyClasses(itemCount) {
    const isEmpty = Number(itemCount || 0) === 0;

    const drawerHost = document.querySelector('cart-drawer');
    if (drawerHost) drawerHost.classList.toggle('is-empty', isEmpty);

    const cartItemsHost = document.querySelector('cart-items');
    if (cartItemsHost) cartItemsHost.classList.toggle('is-empty', isEmpty);

    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.toggle('is-empty', isEmpty);
  }

  function rebindDrawerOverlay() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer
      .querySelector('#CartDrawer-Overlay')
      ?.addEventListener('click', drawer.close?.bind(drawer));
  }

  function refreshAllCounters(cart) {
    const count = Number(cart?.item_count || 0);

   
    document.querySelectorAll('.cart-count-badge').forEach((el) => {
      el.textContent = `(${count})`;
    });

    document
      .querySelectorAll(
        '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not([class])'
      )
      .forEach((el) => {
        el.textContent = String(count);
      });


    document.querySelectorAll('.current_cart_count').forEach((el) => {
      el.dataset.cartCount = String(count);
    });
  }

  async function refreshUI() {
    console.log('[PFAND] refreshUI');
  const cart = await getCart();

  const sectionsToLoad = ['cart-drawer', 'cart-icon-bubble'];

  const mainItemsEl = document.getElementById('main-cart-items');
  const mainFooterEl = document.getElementById('main-cart-footer');

  const mainItemsSectionId = mainItemsEl?.dataset?.id;  
  const mainFooterSectionId = mainFooterEl?.dataset?.id;

  if (mainItemsSectionId) sectionsToLoad.push(mainItemsSectionId);
  if (mainFooterSectionId) sectionsToLoad.push(mainFooterSectionId);

  const sections = await fetchSections(sectionsToLoad);

  // Drawer
  if (sections['cart-drawer']) {
    const doc = parseHTML(sections['cart-drawer']);
    replaceByIdFromHTML('CartDrawer', doc);
  }

  // Bubble
  if (sections['cart-icon-bubble']) {
    const doc = parseHTML(sections['cart-icon-bubble']);
    const srcBubble = doc.querySelector('#cart-icon-bubble');
    if (srcBubble) {
      document.querySelectorAll('#cart-icon-bubble').forEach((dst) => {
        dst.replaceWith(srcBubble.cloneNode(true));
      });
    }
  }


  if (mainItemsEl && mainItemsSectionId && sections[mainItemsSectionId]) {
    const doc = parseHTML(sections[mainItemsSectionId]);
    const src = doc.getElementById('main-cart-items');
    const dst = document.getElementById('main-cart-items');
    if (src && dst) dst.replaceWith(src);
  }

  
  if (mainFooterEl && mainFooterSectionId && sections[mainFooterSectionId]) {
    const doc = parseHTML(sections[mainFooterSectionId]);
    const src = doc.getElementById('main-cart-footer');
    const dst = document.getElementById('main-cart-footer');
    if (src && dst) dst.replaceWith(src);
  }

  setEmptyClasses(cart.item_count);
  refreshAllCounters(cart);
  rebindDrawerOverlay();
}

  async function syncPfandNow() {
    console.log('[PFAND] sync start');
    if (lock) return;
    lock = true;

    try {
      const pfandVariantId = getPfandVariantId();
      const cart = await getCart();

      const neededQty = cart.items.reduce((sum, it) => {
        if (isPfandLine(it, pfandVariantId)) return sum;
        return sum + (isPfandNeeded(it) ? (Number(it.quantity) || 0) : 0);
      }, 0);

      const pfandIndex = cart.items.findIndex((it) => isPfandLine(it, pfandVariantId));
      const pfandLine = pfandIndex >= 0 ? { item: cart.items[pfandIndex], line: pfandIndex + 1 } : null;


      if (neededQty === 0) {
        if (pfandLine) {
          await setLineQty(pfandLine.line, 0);
        }
        await refreshUI();
        return;
      }


      if (pfandLine) {
        if (Number(pfandLine.item.quantity) !== neededQty) {
          await setLineQty(pfandLine.line, neededQty);
        }
        await refreshUI();
        return;
      }

   
      if (!pfandVariantId) return;
      await addPfand(pfandVariantId, neededQty);
      await refreshUI();
    } catch (e) {
      console.warn('pfand sync failed', e);
      try {
        await refreshUI();
      } catch (_) {}
    } finally {
      lock = false;
    }
  }

  function scheduleSync(delay = 250) {
    clearTimeout(timer);
    timer = setTimeout(syncPfandNow, delay);
  }

  window.syncPfand = () => scheduleSync(150);

  document.addEventListener('DOMContentLoaded', () => {
    scheduleSync(200);

   
    try {
      if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (evt?.source === 'pfand') return;
          scheduleSync(350);
          console.log('[PFAND] cartUpdate evt', evt?.source);
        });
      }
    } catch (_) {}

  
    if (window.fetch && !window.__pfandFetchPatched) {
      window.__pfandFetchPatched = true;
      const orig = window.fetch;

      window.fetch = async (...args) => {
        const url = String(args?.[0] || '');
        const opts = args?.[1] || {};
        const headers = opts?.headers || {};
        const isOur =
          headers &&
          (headers[PFAND_HEADER] ||
            (typeof headers.get === 'function' && headers.get(PFAND_HEADER)));

        const res = await orig(...args);

        try {
          const isCartEndpoint =
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear');

          if (!isOur && isCartEndpoint) scheduleSync(250);
        } catch (_) {}

        return res;
      };
    }
  });
})();